import { Routes, Route, Navigate } from 'react-router-dom';
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';

import { DashboardLayout } from './components/Layout/DashboardLayout';
import { Dashboard } from './pages/Dashboard';
import { Search } from './pages/Search';
import { Projects } from './pages/Projects';
import { ProjectDetail } from './pages/ProjectDetail';
import { Documents } from './pages/Documents';
import { PriceSets } from './pages/PriceSets';
import { AdminPanel } from './pages/AdminPanel';
import { Settings } from './pages/Settings';
import { Pipeline } from './pages/Pipeline';
import { BidRoom } from './pages/BidRoom';
import { Agencies } from './pages/Agencies';
import { ImportedItems } from './pages/ImportedItems';

function App() {
    return (
        <>
            <SignedIn>
                <DashboardLayout>
                    <Routes>
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/search" element={<Search />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/pursuits" element={<Pipeline />} />
                        <Route path="/bid-room/:id" element={<BidRoom />} />
                        <Route path="/projects/:id" element={<ProjectDetail />} />
                        <Route path="/projects/:id" element={<ProjectDetail />} />
                        <Route path="/documents" element={<Documents />} />
                        <Route path="/price-sets" element={<PriceSets />} />
                        <Route path="/admin" element={<AdminPanel />} />
                        <Route path="/settings" element={<Settings />} />
                        {/* New Routes */}
                        <Route path="/agencies" element={<Agencies />} />
                        <Route path="/imported" element={<ImportedItems />} />
                    </Routes>
                </DashboardLayout>
            </SignedIn>
            <SignedOut>
                <RedirectToSignIn />
            </SignedOut>
        </>
    );
}

export default App;
